import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Llegás a la clase sin saber exactamente qué secuencia o combinación vas a trabajar hoy', 'Tus alumnos no progresan porque no tenés una estructura clara de nivel a nivel', 'El 40% abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos pasos de siempre porque no tenés más material organizado y listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Siempre las mismas correcciones improvisadas, sin un método claro que te respalde', 'Tenés alumnos de distintos niveles en la misma clase y se convierte en un caos', 'Fin de mes y los alumnos se van sin avisar porque la comunicación con ellos es inconsistente'];
export function PainPointsSection() {
  return <section className="py-12 md:py-24 bg-neutral-900 relative border-y border-neutral-800" data-id="element-181">
      <div className="container mx-auto px-4" data-id="element-182">
        <div className="max-w-4xl mx-auto" data-id="element-183">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center mb-8 md:mb-16" data-id="element-184">
            <h2 className="text-2xl md:text-4xl font-bold text-white" data-id="element-185">
              Si sos profe de ritmos latinos en Argentina, esto te va a sonar
              familiar:
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-16" data-id="element-186">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="flex items-start gap-3 bg-neutral-950 p-3.5 md:p-6 rounded-lg md:rounded-xl border border-neutral-800/50" data-id="element-187">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-188" />
                <p className="text-neutral-300 text-sm md:text-base leading-snug" data-id="element-189">
                  {point}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-190">
            <h3 className="text-2xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-amber-500" data-id="element-191">
              ¿Cuántas clases más vas a improvisar?
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}